export function createDropdownMenu(
  items: string[],
  onSelect: (selected: string) => void,
  addLinkUrl?: string,
  addLinkText: string = 'No items found. Click here to add.'
): HTMLDivElement {
  const menu = document.createElement('div');
  menu.classList.add('quill-dropdown-menu');
  menu.tabIndex = 0; // Make menu focusable
  menu.style.position = 'absolute';
  menu.style.background = 'var(--card-background)';
  menu.style.boxShadow = 'var(--quill-dropdown-menu-shadow)';
  menu.style.padding = '8px';
  menu.style.borderRadius = '5px';
  menu.style.zIndex = '1000';
  menu.style.maxWidth = '300px';
  menu.style.maxHeight = '200px';
  menu.style.overflowY = 'auto';

  if (items.length === 0 && addLinkUrl && addLinkText) {
    const link = document.createElement('a');
    link.textContent = addLinkText;
    link.href = addLinkUrl || '#';
    link.target = '_blank';
    link.style.display = 'block';
    link.style.padding = '5px';
    link.style.color = '#1976d2';
    link.style.textDecoration = 'underline';
    menu.appendChild(link);
    return menu;
  }


  // --- Search bar ---
  const searchInput = document.createElement('input');
  searchInput.type = 'text';
  searchInput.placeholder = 'Search...';
  searchInput.style.width = '100%';
  searchInput.style.marginBottom = '8px';
  searchInput.style.padding = '5px';
  searchInput.style.boxSizing = 'border-box';
  searchInput.style.position = 'sticky';
  searchInput.style.top = '0';
  searchInput.style.background = 'var(--card-background)';
  searchInput.style.zIndex = '10';
  menu.appendChild(searchInput);

  let filteredItems = [...items];
  let optionDivs: HTMLDivElement[] = [];
  let selectedIndex = 0;

  function renderOptions() {
    // Remove old options
    optionDivs.forEach(div => menu.contains(div) && menu.removeChild(div));
    optionDivs = [];
    filteredItems.forEach((item, idx) => {
        const div = document.createElement('div');
        div.textContent = item;
        div.style.padding = '5px';
        div.style.cursor = 'pointer';
        div.tabIndex = -1;
        div.addEventListener('click', () => {
            onSelect(item);
            menu.remove();
        });
        div.addEventListener('mouseenter', () => {
            selectedIndex = idx;
            updateHighlight();
        });
        optionDivs.push(div);
        menu.appendChild(div);
    });
    updateHighlight();
  }

  function updateHighlight() {
    optionDivs.forEach((div, idx) => {
      if (idx === selectedIndex) {
        div.style.background = 'var(--surface-200)';
      } else {
        div.style.background = '';
      }
    });
  }

  searchInput.addEventListener('input', () => {
    const val = searchInput.value.toLowerCase();
    filteredItems = items.filter(item => item.toLowerCase().includes(val));
    selectedIndex = 0;
    renderOptions();
  });

  menu.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowDown') {
      selectedIndex = (selectedIndex + 1) % optionDivs.length;
      updateHighlight();
      optionDivs[selectedIndex]?.scrollIntoView({ block: 'nearest' });
      e.preventDefault();
    } else if (e.key === 'ArrowUp') {
      selectedIndex = (selectedIndex - 1 + optionDivs.length) % optionDivs.length;
      updateHighlight();
      optionDivs[selectedIndex]?.scrollIntoView({ block: 'nearest' });
      e.preventDefault();
    } else if (e.key === 'Enter') {
      optionDivs[selectedIndex]?.click();
      e.preventDefault();
    }
  });

  // Initial render
  renderOptions();

  // Focus the search input when menu appears
  setTimeout(() => searchInput.focus(), 0);

  return menu;
}

export function positionDropdown(
  menu: HTMLDivElement,
  button: HTMLElement,
  container: HTMLElement
): void {
  const buttonRect = button.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  menu.style.position = 'absolute';
  menu.style.top = `${buttonRect.bottom - containerRect.top}px`; // Position below button
  menu.style.left = `${buttonRect.left - containerRect.left}px`;
}
